/**
 * ============================================================
 * 前景图片配置
 * ============================================================
 * PC 和移动端共用此配置
 * 图片按顺序从左到右排列，自动拼接
 */
export default [
  { src: "./xiangan/前景/前景_01.webp" },
  { src: "./xiangan/前景/前景_02.webp" },
  { src: "./xiangan/前景/前景_03.webp" },
  { src: "./xiangan/前景/前景_04.webp" },
  { src: "./xiangan/前景/前景_05.webp" },
  { src: "./xiangan/前景/前景_06_01.webp" },
  { src: "./xiangan/前景/前景_06_02.webp" },
  { src: "./xiangan/前景/前景_06_03.webp" },
  { src: "./xiangan/前景/前景_06_04.webp" },
  { src: "./xiangan/前景/前景_06_05.webp" },
];

